/*
 * Copyright (c) Worldline 2023.
 */

export const SbxEvents = {
    // will send the new cookieAgreementStatus, see enumeration
    COOKIE_AGREEMENT: '$sbxCookieAgreement',
    DOCUMENT_FULLY_READ: '$sbxDocumentFullyRead',
    PDFVIEWER_INJECTED: '$sbxPdfviewerInjected',
    PDFJSVIEWER_INJECTED: '$sbxPdfJsviewerInjected'
};
